import dynamic from 'next/dynamic';
import styles from './SliderDocument.module.scss';
import CircularProgress from '#components/feedback/circular-progress/CircularProgress';
import { SliderDocumentBlock } from '#types/generated/graphql-types';

const HeroSlider = dynamic(
  () => import('#components/sections/hero-slider/HeroSlider'),
  {
    ssr: false,
    loading: () => (
      <div className={styles.placeholder}>
        <CircularProgress size={30} />
      </div>
    ),
  }
);

type Props = {
  block: SliderDocumentBlock;
};

const SliderDocumentBlock = ({ block }: Props) => {
  return (
    <div className={`tw-mb-5 medium-up:tw-mb-8 ${styles.host}`}>
      <HeroSlider items={block.items} />
    </div>
  );
};

export default SliderDocumentBlock;
